import { appDayJs } from '../../../lib/models/Time';

export const formatDateForTable = (date: Date | string, toDefTime?: boolean) => {
  if (toDefTime) {
    return date ? appDayJs(date).format('MMM DD YYYY') : undefined;
  }

  return date ? appDayJs(date).utc().format('MMM DD YYYY') : undefined;
};
